module.exports = __webpack_public_path__ + "img/02kyzx_zngz.ee00fafc.png";